// extracted by mini-css-extract-plugin
module.exports = {"text":"Gallery_text__1zXZ2"};